'use client';

import {
  GalleryCardComponent as GalleryCard,
  GalleryCardProps,
} from '@vaad1st/component.molecule.gallery-card';
import styles from './gallery-card.component.module.less';
import { useState, useEffect } from 'react';
import { checkCardBadge } from 'src/utils';
import classNames from 'classnames';
import { HeadingElement } from 'src/utils/shared-types';
import { appendDomainToImageRenditions } from 'src/utils/component-utils/utils';

interface GalleryCardComponentProps extends GalleryCardProps {
  titleElement?: HeadingElement;
  cardType?: string;
  textIsRich?: boolean;
  halfCardHeight?: boolean;
  'sling:resourceType'?: string;
  'cq:panelTitle'?: string;
}

export default function GalleryCardComponent({
  titleElement = HeadingElement.H2,
  ...props
}: GalleryCardComponentProps) {

  const [isMounted, setIsMounted] = useState(false);
  const [cardProps, setCardProps] = useState<any>(null);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      checkCardBadge(props);
      delete props['cq:panelTitle'];
      delete props['sling:resourceType'];
      delete props['halfCardHeight'];

      const { cardType, textIsRich, image, ...rest } = props;
      const updatedImages = appendDomainToImageRenditions(image);
      setCardProps({ titleElement, ...rest, image: updatedImages });
      setIsMounted(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMounted]);

  return (
    isMounted &&
    cardProps && (
      <div
        className={classNames(styles['gallery-card'], {
          [styles['gallery-card__half']]: props.halfCardHeight,
        })}
      >
        <GalleryCard {...cardProps} />
      </div>
    )
  );
}
